/**
 * Use this in the default case of a switch statement for enum exhaustion compile-time assertion.
 */
export function assertUnreachable(type) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    throw new Error(`Didn't expect to get here: ${JSON.stringify(type).slice(0, 100)}`);
}
